module.exports = __webpack_public_path__ + "static/media/standing-banner.3efea392.png";